type RedirectArgs = {
    photoOrderId: number | null;
    digitalStylingOrderId: number | null;
    planOrderId: number | null;
};

export function getRedirectPathToOrder({
    photoOrderId,
    digitalStylingOrderId,
    planOrderId
}: RedirectArgs): string {
    if (digitalStylingOrderId && planOrderId) {
        return `/orders/${digitalStylingOrderId}/digital-styling?newOrder=1&redirectTo=/orders/${planOrderId}/plan?newOrder=1`;
    }
    
    if (digitalStylingOrderId) {
        return `/orders/${digitalStylingOrderId}/digital-styling?newOrder=1`;
    }
    
    if (planOrderId) {
        return `/orders/${planOrderId}/plan?newOrder=1`;
    }

    return `/orders/${photoOrderId}/basic`;
}
